
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 3.25a.75.75 0 000 1.5h2.19l-3.72 3.72a.75.75 0 001.06 1.06l3.72-3.72V8a.75.75 0 001.5 0V4a.748.748 0 00-.75-.75h-4zM4.75 16a.75.75 0 00-1.5 0v4a.747.747 0 00.75.75h4a.75.75 0 000-1.5H5.81l3.72-3.72a.75.75 0 10-1.06-1.06l-3.72 3.72V16zM20 15.25a.75.75 0 01.75.75v4a.748.748 0 01-.75.75h-4a.75.75 0 010-1.5h2.19l-3.72-3.72a.75.75 0 111.06-1.06l3.72 3.72V16a.75.75 0 01.75-.75zM3.307 3.713A.748.748 0 003.25 4v4a.75.75 0 101.5 0V5.81l3.72 3.72a.75.75 0 001.06-1.06L5.81 4.75H8a.75.75 0 100-1.5H4a.748.748 0 00-.529.218l-.001.002-.002.001a.748.748 0 00-.161.242z"}})])
          )
        }
      }
    